import logo from '../assets/logo.svg';
import logoWhite from '../assets/logo-white.svg';
import { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useAuth } from '../contexts/AuthContext';
import { Button, Dropdown } from 'antd';
import Data from '../data/Data';

gsap.registerPlugin(ScrollTrigger);

function Header({ backgroundEffect, background, whiteLogo, authButton, sticky }) {
    const { isLoggedIn, logout } = useAuth();
    const [userData, setUserData] = useState('');

    const items = [
        {
          key: 'Dashboard',
          label: (
            <div onClick={() => window.location = '/dashboard'}>
              Dashboard
            </div>
          ),
        },
        {
            key: 'Settings',
            label: (
              <div onClick={() => window.location = '/user-settings'}>
                Settings
              </div>
            ),
        },
        {
            key: 'ChangeProfileType',
            label: (
              <div onClick={() => Data.changeUserType()}>
                Switch to {Data.getUserType() === 'customer' ? 'designer' : 'customer'}
              </div>
            ),
        },
        {
          key: 'SignOut',
          label: (
            <div onClick={logout}>
              Sign out
            </div>
          ),
          danger: true
        },
    ];

    useEffect(() => {
        if (backgroundEffect) {
            gsap.fromTo('nav', {
                backgroundColor: '#00000000'
            }, {
                backdropFilter: 'blur(10px)',
                backgroundColor: '#f1faff50',
                ease: 'power1.inOut',
                scrollTrigger: {
                    trigger: '#landing',
                    start: 'center center',
                    end: 'bottom center',
                    scrub: true,
                },
            });

            gsap.fromTo('.navbar-brand', {
                opacity: 0,
            }, {
                opacity: 1,
                ease: 'power1.inOut',
                scrollTrigger: {
                    trigger: '#landing',
                    start: '60% center',
                    end: '70% center',
                    scrub: true,
                },
            });
        }
    }, [backgroundEffect]);

    async function fetchUser() {
        setUserData(await Data.fetchUser());
    }

    useEffect(() => {
        if (isLoggedIn) {
            try {
                fetchUser();
            } catch (e) {
                logout();
            }
        }
    }, [isLoggedIn, logout])
    
    
    return (
        <div className='Header'>
            <nav className={'navbar' + (background ? ' nav-top' : '') + (sticky ? ' sticky-top' : '')}>
                <div className="container-fluid">
                    <a className="navbar-brand" href="/">
                        <img src={whiteLogo ? logoWhite : logo} alt="sb-dt" className='img-fluid' />
                    </a>
                    { authButton && (
                        <div>
                            {isLoggedIn ? (
                                <Dropdown menu={{ items }} placement="bottomRight">
                                    <Button>{userData && (`${userData.firstName} ${userData.lastName} (${Data.getUserType()})`)}</Button>
                                </Dropdown>
                            ) : (
                                <button className="btn btn-primary btn-sm" type="submit" onClick={() => window.location.href = '/login'}>Belépés</button>
                            )}
                        </div>
                    )}
                </div>
            </nav>
        </div>
    )
}

export default Header;